// extracted by mini-css-extract-plugin
export default {"section":"GetStarted_section__lovS5","wrapper":"GetStarted_wrapper__aKPR3","form":"GetStarted_form__aQfsD","submitBtn":"GetStarted_submitBtn__zQ+YZ"};